import i18n from "@breward/i18n";

export const STAFF_MEMBER_ROLES = {
  member: {
    label: i18n.t("global:shared.StaffMemberRole.Member", "Member"),
  },
  admin: {
    label: i18n.t("global:shared.StaffMemberRole.Admin", "Admin"),
  },
};

export const STAFF_MEMBER_NOTIFICATIONS = {
  entryRegisteredEmail: {
    label: i18n.t(
      "global:shared.StaffMemberNotification.entryRegistered",
      "Entry registered email"
    ),
  },
  bankTransferPaymentEmail: {
    label: i18n.t(
      "global:shared.StaffMemberNotification.bankTransfer",
      "Bank transfer payment email"
    ),
  },
  orderPaidEmail: {
    label: i18n.t(
      "global:shared.StaffMemberNotification.orderPaid",
      "Order paid email"
    ),
  },
  judgeApplicationReceivedEmail: {
    label: i18n.t(
      "global:shared.StaffMemberNotification.judgeApplicationReceived",
      "Judge applied email"
    ),
  },
};
